module.exports = __webpack_public_path__ + "static/media/blogger-social-media-svgrepo-com.228c6428.svg";